import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
        if (data.carrier) {
            datas.assignment_id = data.carrier
        }
        if (data.company) {
            datas.company_id = data.company
        }
    }
    return ApiService.get(
        `/rate-card-template/fuel-levy/${data?.carrier ? 'see_more/' : ''}`,
        datas,
    )
}
export const createApiRecord = (data) =>
    ApiService.post('/rate-card-template/fuel-levy/', data)
export const getApiRecord = (id) =>
    ApiService.get(`/rate-card-template/fuel-levy/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.patch(`/rate-card-template/fuel-levy/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/rate-card-template/fuel-levy/${id}/`, data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/rate-card-template/fuel-levy', id)
export const bulkUploadApi = (data) =>
    ApiService.filePost('/rate-card-template/fuel-levy-upload/', data)
